import {
    FETCH_AUDIT_TRAIL_REQUEST,
    FETCH_AUDIT_TRAIL_SUCCESS,
    FETCH_AUDIT_TRAIL_ERROR,
    HIDE_AUDIT_TRAIL_LOADER,
    SHOW_AUDIT_TRAIL_LOADER,
} from './auditTrail.constants';

export const fetchAuditTrailRequest = payload => ({
    type: FETCH_AUDIT_TRAIL_REQUEST,
    payload,
});

export const fetchAuditTrailSuccess = payload => ({
    type: FETCH_AUDIT_TRAIL_SUCCESS,
    payload,
});

export const fetchAuditTrailError = payload => ({
    type: FETCH_AUDIT_TRAIL_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_AUDIT_TRAIL_LOADER });

export const hideLoader = () => ({ type: HIDE_AUDIT_TRAIL_LOADER });
